import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class CreateCourseType extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("CourseType/Create");
  }
  setParams(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetCourseType extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("CourseType/GetBy");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}
class GetCourseTypes extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("CourseType/GetAll");
  }
  setParams(data) {
    super.setRequestParam(data);
  }
}
class DeleteACourseType extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("CourseType/DeleteBy");
  }
  setParams(data) {
    super.setParams(data);
  }
}
class UpdateACourseType extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("CourseType/Update");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

export {
  CreateCourseType,
  GetCourseTypes,
  DeleteACourseType,
  UpdateACourseType,
  GetCourseType,
};
